import React from "react";
import { Button, type ButtonSize } from "@design-system/Button/Button";
import { RequestCodeFn } from "./types";
import { UseResend, useResend } from "./useResend";

interface Props {
    request: RequestCodeFn;
    children?: (params: UseResend) => React.ReactElement | null;
    btnSize?: Exclude<ButtonSize, "xs">;
}

export const ResendCode: React.FC<Props> = ({ request, children, btnSize }) => {
    const resend = useResend(request);

    if (children) {
        return children(resend);
    }

    return (
        <Button
            type="button"
            variant="secondary"
            size={btnSize ?? "md"}
            onClick={resend.handleResend}
            disabled={resend.resendBlocked}
        >
            {!resend.resendBlocked ? <>Resend code</> : <>Code re-sent</>}
        </Button>
    );
};
